var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"message-history__message"},[_c('div',{staticClass:"small",class:{'pull-right': _vm.fromCustomer},domProps:{"textContent":_vm._s(_vm.formattedDate)}}),_c('div',{staticClass:"clearfix"}),_c('div',{staticClass:"bubble",class:{
      'from-me': _vm.fromCustomer,
      'primary-bg': _vm.fromCustomer,
      'secondary-bg': !_vm.fromCustomer,
      'pull-right': _vm.fromCustomer
    }},[_c('pre',[_c('span',[_vm._v(_vm._s(_vm.message.message.trim()))])])]),_c('div',{staticClass:"clearfix"})])
}
var staticRenderFns = []

export { render, staticRenderFns }